import React from 'react';

const Movies = () => {
  return <div>Movies Dashboard</div>
}

export default Movies;
